module.exports = __webpack_public_path__ + "static/media/m3sred.3ec0a35e.png";